import BaseApi from './baseAPI'

class authAPI extends BaseApi{

  get entity() {
    return {
      route: `/`,
      name: ''
    }
  }

  login(data){
    return new Promise((resolve, reject) => {
      this.request.post('/login', data)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  register(data){
    return new Promise((resolve, reject) => {
      this.request.post('/register', data)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  requestTeacherRole(data){
    return new Promise((resolve, reject) => {
      this.request.post('/request-teacher-role', data)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  isLoggedIn(){
    return new Promise((resolve, reject) => {
      this.request.get('/is-logged-in')
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  refreshToken(){
    return new Promise((resolve, reject) => {
      this.request.get('/refresh')
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  verifyEmail(email, token) {
    return new Promise((resolve, reject) => {
      this.request.get('/verify-email', {
        params: {
          email: email,
          token: token
        }
      })
          .then(response => resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
    })
  }

  identifyUser(email) {
    return new Promise((resolve, reject) => {
      this.request.get('/identify-user', {
        params: {
          email: email,
        }
      })
          .then(response => resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
    })
  }

  resetPassword(email, token, password, password_confirmation) {
    return new Promise((resolve, reject) => {
      this.request.post('/reset-password', {
        email: email,
        token: token,
        password: password,
        password_confirmation: password_confirmation

      })
          .then(response => resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
    })
  }

  logout(){
    return new Promise((resolve, reject) => {
      this.request.get('/logout')
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

}

export default new authAPI()
